<template>
  <div>
    <el-tabs type="card" v-model="activeName">
    <el-tab-pane label="预警信息" name="1" >
      <div v-loading="loading">
        <div v-if="!loading">
          <QS-h4-title title="基本信息"/>
          <QS-column-box :labelWidth="140" separator=":" :column="3" :list="config.baseInfoList" :source="source"/>
          <QS-h4-title title="预警信息"/>
          <QS-column-box :labelWidth="140" separator=":" :column="3" :list="config.warnInfoList" :source="source"/>
          <QS-h4-title title="风险信息"/>
          <column-box-expand  :labelWidth="140" separator=":" :column="3" :list="config.riskInfoList" :source="source">
            <div slot="currentDebt">
              <el-tooltip class="item" effect="dark" placement="top-start">
                <div slot="content">
                  <div>计算规则：</div>
                  <div>1.履约中、退车待验车、订单待核算状态的订单，当前周期租金欠款=当前周期使用天数*当前周期平均日租金-当期已收金额</div>
                  <div>2.用待结算和已关闭状态的订单，当前周期租金欠款=订单退车结算计算的当前周期租金的剩余应收金额</div>
                  <div>
                    <div>计算说明：</div>
                    <div>{{source.currentDebtRemarks}}</div>
                  </div>
                </div>
                <div class="ellipsis ml16">{{source.currentDebtRemarks}}</div>
              </el-tooltip>
            </div>
            <el-button class="ml16" v-if="judgePermission('financeCollection')&&source.orderId" slot="pastDebt" type="text" @click="jumpPage('collection')">应收单详情</el-button>
            <el-button class="ml16" v-if="judgePermission('vehicle_violation_record')&&source.orderId" slot="pendingViolateAmount" type="text" @click="jumpPage('violationRecord')">违章详情</el-button>
          </column-box-expand>
          <el-divider></el-divider>
          <QS-column-box :labelWidth="140" separator=":" :column="3" :list="config.riskInfoSubList" :source="source"/>
          <QS-h4-title title="预警变更记录"/>
          <QS-common-table
            :loading="loading"
            :data="list"
            :columns="config.recordColumn"
            :pagination="paginationData"
            @change="paginationChange"
          />
        </div>
      </div>
    </el-tab-pane>
    <el-tab-pane label="跟进记录" name="2">
      <el-timeline v-if="activities.length>0">
        <el-timeline-item
          v-for="(activity, index) in activities"
          :key="index"
          :title="activity.followDesc">
          <div class="follow_info mb16">
            <span>跟进人：{{activity.createUser||'--'}}</span>
            <span class="ml16">跟进时间：{{activity.gmtCreate||'--'}}</span>
          </div>
          <show-img-and-file :list="activity.photo" emptyText="" />
        </el-timeline-item>
      </el-timeline>
      <div v-else>暂无</div>
    </el-tab-pane>
  </el-tabs>
  </div>
</template>
<script>
import config from './config'
// eslint-disable-next-line import/no-cycle
import { getRiskDetail, modifyRecordList, followList } from '@/api/domain/orders'

export default {
  data() {
    return {
      source: { },
      config: config.call(this),
      loading: false,
      list: [],
      paginationData: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
        pageSizes: [10, 20, 30, 50],
      },
      activities: [],
      activeName: '1',
      pages: {
        collection: {
          path: '/finance/collection',
          query: {},
        },
        violationRecord: {
          path: '/vehicle/violation/record',
          query: {},
        },
      },
    }
  },
  created() {
    this.id = this.$route.query.id || ''
    this.getList()
    this.getDetail()
  },
  // 该页面是被缓存的，组件初次加载或者组件激活时重新获取跟进记录
  activated() {
    this.getFollowList()
  },
  methods: {
    // 处理不固定信息
    // 费用待结算和已关闭状态的订单，风控详情增加显示字段 租金退款，押金退款
    dealOtherInfo() {
      // 费用待结算和已关闭状态
      if ([5000, 5500].includes(this.source.orderStateCode)) {
        this.source.amountRatio = `${this.source.amountRatio || '--'}（费用待结算、已关闭状态的订单已占押金比例=风控欠款总计/（租金退款+押金退款）*100%）`
        return
      }
      // 租金退款
      const carInd = this.config.riskInfoSubList.findIndex((item) => item.key === 'rentReturnAmount')
      this.config.riskInfoSubList.splice(carInd, 1)
      // 押金退款
      const depositInd = this.config.riskInfoSubList.findIndex((item) => item.key === 'depositReturnAmount')
      this.config.riskInfoSubList.splice(depositInd, 1)
      // 实收押金 非费用待结算和已关闭状态的订单 待退款金额总计显示为实收押金
      const receivedDepositInd = this.config.riskInfoSubList.findIndex((item) => item.key === 'receivedDeposit')
      this.config.riskInfoSubList[receivedDepositInd].name = '实收押金'
      this.source.amountRatio = `${this.source.amountRatio || '--'}（履约中、退车待验车、订单待核算状态的订单已占押金比例=风控欠款总计/实收押金*100%）`
    },
    // 获取详情
    getDetail() {
      getRiskDetail({ id: this.id }).then((res) => {
        this.source = res.data || {}
        this.setPagesQuery()
        this.dealOtherInfo()
      })
    },
    // 获取跟进记录
    getFollowList() {
      followList({
        bizId: this.id,
        sourceType: 2, // 跟进类型 1.逾期 2.风控
      }).then((res) => {
        const result = res.data || []
        result.forEach((element) => {
          element.photo = this.getEchoUploadFileData(element.photo, true)
        })
        this.activities = result
      })
    },
    // 处理页面query
    setPagesQuery() {
      this.pages.collection.query = { sourceOrderId: this.source.orderId, receivableStates: 0 }
      this.pages.violationRecord.query = { orderId: this.source.orderId, handleState: 0 }
    },
    // 跳转页面逻辑
    jumpPage(type) {
      const { path, query } = this.pages[type]
      this.$router.push({ path, query })
    },
    getList() {
      modifyRecordList({
        pageNum: this.paginationData.pageNum,
        pageSize: this.paginationData.pageSize,
        id: this.id,
      }).then((res) => {
        this.list = res.data.items || []
      })
    },
    paginationChange(payload) {
      const { pagination } = payload
      this.paginationData.pageSize = pagination.pageSize
      this.paginationData.pageNum = pagination.pageNum
      this.getList()
    },
  },
}
</script>
<style lang="scss" scoped>
.ellipsis{
  width: 100px;  //宽度
  overflow: hidden;  //超出文本隐藏
  white-space: nowrap;  //不换行，只显示一行
  text-overflow: ellipsis;  //超出部分省略号显示
}
.follow_info{
  color:#666;
}
::v-deep .el-divider--horizontal{
  margin: 0;
  margin-bottom: 16px;
}
</style>
